import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Echarts,
  SelectTree,
  Select,
  DatePicker,
  ButtonGroup,
  OverlayTrigger,
  PopOver,
  Button
 } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { SubAccountSelector } from './subAccountSelector';
import { leadsTypeTreeForTableFilter } from '../../../consts/leadsTypeTree';
import { leadsSourceMap } from '../setting/clue/leadsSourceMap';
import { UploadDetailTable } from './uploadDetailTable';
import { getSubaccountFromLocalStorage, dmpTypeMap } from './util';
import { Common } from '../../../consts/Common';

const barChartLegendStyle = {
    bottom: '-5',
    textAlign: 'center',
  };


const DataSources = [{
  value: 'leads-web',
  label: '线索管理平台'
}, {
  value: 'action-api',
  label: '行为数据接口'
}];
const ActionPaths = {
  1: '表单',
  2: '公众号',
  3: '企微',
  4: '个微',
  5: 'APP',
  6: '下单',
};
const getValueAreaComponent = prefix => (props) => {
  const { onOpen, label, placeholder, date, startDate, endDate, type } = props;
  return (
    <div>
      <div className='datechoose' onClick={onOpen}>
        <span>{prefix}：{label}</span>
      </div>
    </div>
  );
};
const ValueAreaComponent = (props) => {
  const { value, data, multiple, onOpen, open, placeholder }  = props;
  return (
    <a
      onClick={onOpen}
      className='selection-single'
    >
      <span className='selection-single-text'>
          投放链路：
          {
            value ?
              Object.values(data).map(item => item.desc).join(', ')
              :
              placeholder || '请选择'
          }
      </span>
      <div className='selection-arrow'>
        <svg width='16px' height='16px' viewBox='0 0 16 16'><g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' strokeLinecap='square'><polyline stroke='#B8BCC2' points='4 6 8.5 10.5 13 6'></polyline></g></svg>
      </div>
  </a>
  );
};
let timer;
const debounce = (func, timeout = 800) => {
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
export const TotalUploadDetail = (props) => {
  const option = (entities = [[]]) => ({
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['有效', '潜在', '到店', '成单', '无效'],
      ...barChartLegendStyle,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '8%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: [],
    title: {
      show: entities.length === 0,
      textStyle: {
          color: "grey",
          fontSize: 20
      },
      text: "暂无数据",
      left: "center",
      top: "center"
    },
  });
  const startDate = moment().subtract(14, 'days').format('YYYY-MM-DD');
  const endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const [queryAccountId, setQueryAccountId] = useState(getSubaccountFromLocalStorage() || window.pageProps.uid);
  const [actionSubTypes, setLeadsType] = useState([]);
  const [leadsSources, setLeadsSource] = useState([]);
  const [dateRange, setDateRange] = useState({ startDate, endDate });
  const [dateRangeForAction, setDateRangeForAction] = useState({ startDate: dateRange.startDate > '2022-12-22' ? dateRange.startDate : '2022-12-22', endDate });
  const [dateRangeForDownload, setDateRangeForDownload] = useState({ startDate: dateRange.startDate > '2022-12-22' ? dateRange.startDate : '2022-12-22', endDate });
  const [trendChartOption, setTrendChartOption] = useState(option());
  const [dataSource, setDataSource] = useState('leads-web');
  const [ActionPathList, setActionPathList] = useState([]);
  const [actionPaths, setActionPaths] = useState([1]);
  const [actionPaths2, setActionPaths2] = useState([1]);
  const [confirmBtnDisabled, setButtonDisabled] = useState(false);
  
  useEffect(() => {
    RPCFactory.DMPUpload.getActionPathList()
    .done((data) => {
      setActionPathList(data.linkPaths);
    })
    .fail((ret, msg) => {
      alert(msg);
    });
    onConfirmGetChartData();
  }, []);

  useEffect(() => {
    onConfirmGetChartData();
  }, [dataSource]);

  const onConfirmGetChartData = () => {
    if (dataSource === 'leads-web') {
      getChartData(getParamFromLeads);
    } else {
      getChartData(getParamFromAction);
    }
  };

  const getParamFromLeads = () => {
    return  {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      queryAccountId,
      ... (actionSubTypes.length ? { actionSubTypes } : {}),
      ... (leadsSources.length ? { leadsSources } : {}),
    };
  };
  const getParamFromAction = (part = 'chart') => {
    return  {
      startDate: part == 'chart' ? dateRangeForAction.startDate : dateRangeForDownload.startDate,
      endDate: part == 'chart' ? dateRangeForAction.endDate : dateRangeForDownload.endDate,
      accountId: queryAccountId,
      ... (actionPaths.length ? { linkPaths: actionPaths } : {}),
    };
  };
  const getChartData = (getParaFunc) => {
    let getChartFunc = RPCFactory.DMPUpload.getDmpUploadDistribution;
    if (dataSource !== 'leads-web') {
      getChartFunc = RPCFactory.DMPUpload.getActionAPIDistribution;
    }
    const param = getParaFunc();
    setButtonDisabled(true);
    getChartFunc(param)
      .done((data) => {
        getEchartOptions(data.leadsReportTrendData.entities);
        setButtonDisabled(false);
      })
      .fail((ret, msg) => {
        alert(msg);
        setButtonDisabled(false);
      });
  };
  const handleLeadsTypeChange = (e, value) => {
    setLeadsType(value);
  };
  const handleLeadsSourceChange = (e, value) => {
    setLeadsSource(value);
  };
  const handleActionPathChange = (type='chart') => (e, value) => {
    if(type == 'chart') {
      setActionPaths(value);
    } else {
      setActionPaths2(value);
    }
  }
  const handleDateChange = (event, startDate, endDate) => {
    setDateRange({ startDate, endDate });
  };
  const handleDateChangeForAction = (event, startDate, endDate) => {
    setDateRangeForAction({ startDate, endDate });
  };
  const handleChangeSubaccount = (value) => {
    setQueryAccountId(value);
  };
  const getEchartOptions = (entities) => {
    const newOption = { ...option(entities) };
    const dates = entities.length ? entities[0].subItems.map(item => item.label.slice(5)) : [];
    const series = entities.map(item => {
      const base = dmpTypeMap[item.label];
      base.type = 'line';
      base.data = item.subItems.map(item => item.value);
      return base;
    });
    const lengend = entities.map(item => dmpTypeMap[item.label].name);
    newOption.legend.data = lengend;
    newOption.xAxis.data = dates;
    newOption.series = series;
    setTrendChartOption(newOption);
  };
  const handleDownloadDetail = () => {
    if (dataSource === 'leads-web') {
      const params = new URLSearchParams(getParamFromLeads());
      params.append('accountId', window.pageProps.uid);
      console.log(`${Common.LEADS_DMP_DETAIL_UPLOAD_DOWNLOAD}?${params.toString()}`);
      window.location.href = `${Common.LEADS_DMP_DETAIL_UPLOAD_DOWNLOAD}?${params.toString()}`;
    } else {
      const params = new URLSearchParams(getParamFromAction('download'));
      params.append('accountId', window.pageProps.uid);
      console.log(`${Common.LEADS_ACTION_DETAIL_UPLOAD_DOWNLOAD}?${params.toString()}`);
      window.location.href = `${Common.LEADS_ACTION_DETAIL_UPLOAD_DOWNLOAD}?${params.toString()}`;
    }
  };
  return (
    <main className="main" id="analysis-upload">
      <SubAccountSelector onChange={handleChangeSubaccount}/>
      <div className="card padding-normal no-margin">
        <div className="card-title">
          <span>数据概览</span>
        </div>
        <div className="data-filter-source-part">
          <div className="data-source">
            <span className="left">数据源
            <OverlayTrigger
              trigger="hover"
              placement="top"
              overlay={
                <PopOver>
                  行为数据为全量数据，包括直接通过dmp行为数据接口回传未沉淀在线索管理平台的数据。
                </PopOver>
              }
            >
              <i style={{ marginLeft: '3px' }} className="spaui-icon icon-help" />
            </OverlayTrigger></span>
            <ButtonGroup
              data={DataSources}
              value={dataSource}
              onChange={(event, value, buttonProps) => {
                setDataSource(value);
                console.log(value);
              }}
            />
          </div>
          <div className="data-filter">
            <span className="left">筛选条件</span>
            {dataSource === 'leads-web' && <div className='overview-tip right'>
              <DatePicker
                input
                useNewUI
                useShortcut
                showPanelFooter={false}
                hideSubmitButton={true}
                format='xxxx-xx-xx'
                type='range'
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onChange={handleDateChange}
                className="date-picker"
              />
              <SelectTree
                clear
                multiple
                data={leadsTypeTreeForTableFilter}
                value={actionSubTypes}
                onChange={handleLeadsTypeChange}
                placeholder="全部线索类型"
                className="leads-type"
              />
              <Select
                clear
                multiple
                search={false}
                data={Object.keys(leadsSourceMap).map((key) => ({
                  value: key,
                  label: leadsSourceMap[key],
                }))}
                value={leadsSources}
                onChange={handleLeadsSourceChange}
                placeholder="全部来源"
                className="leads-source"
              />
            </div>}
            {dataSource === 'action-api' && <div className='overview-tip right'>
              <DatePicker
                input
                useNewUI
                useShortcut
                showPanelFooter={false}
                hideSubmitButton={true}
                format='xxxx-xx-xx'
                type='range'
                optionalStartDate='2022-12-22'
                startDate={dateRangeForAction.startDate}
                endDate={dateRangeForAction.endDate}
                onChange={handleDateChangeForAction}
                className="date-picker action-path"
                ValueAreaComponent={getValueAreaComponent('数据上报时间')}
                style={{ width: '330px' }}
              />
              <Select
                clear
                multiple
                search={false}
                data={ActionPathList}
                value={actionPaths}
                valueFieldName='code'
                labelFieldName='desc'
                onChange={handleActionPathChange('chart')}
                placeholder="全部"
                className="action-path"
                ValueAreaComponent={ValueAreaComponent}
              />
            </div>}
            <Button
              displayType="primary"
              style={{ marginLeft: '10px' }}
              onClick={onConfirmGetChartData}
              disabled={confirmBtnDisabled}
            >确定</Button>
          </div>
        </div>
        <Echarts
            {...trendChartOption}
            style={{
              height: 400,
              width: '95%',
            }}
        />
      </div>

      <div className="card padding-normal">
        <div className="card-title">
          <span className="left">数据上报明细记录</span>
          <div className='detail-download right'>
            {dataSource === 'action-api' &&
              <DatePicker
                style={{ width: '350px' }}
                input
                useNewUI
                useShortcut
                showPanelFooter={false}
                hideSubmitButton={true}
                format='xxxx-xx-xx'
                type='range'
                optionalStartDate='2022-12-22'
                startDate={dateRangeForDownload.startDate}
                endDate={dateRangeForDownload.endDate}
                onChange={(event, startDate, endDate) => {
                  setDateRangeForDownload({ startDate, endDate });
                }}
                className="date-picker detail-dowload"
                ValueAreaComponent={getValueAreaComponent('浅层行为发生时间')}
              />
            }
            {dataSource === 'action-api' &&
              <Select
                clear
                multiple
                search={false}
                data={ActionPathList}
                value={actionPaths2}
                valueFieldName='code'
                labelFieldName='desc'
                onChange={handleActionPathChange('detail')}
                placeholder="全部"
                className="action-path"
                ValueAreaComponent={ValueAreaComponent}
                style={{ width: '200px', fontWeight: 500, marginTop: '-8px', marginRight: '5px' }}
              />
            }
            <i className="icon icon-download"></i>
            <span className="spaui-text" onClick={handleDownloadDetail}>下载数据</span>
          </div>
        </div>
        <UploadDetailTable
          queryAccountId={queryAccountId}
          actionSubTypes={actionSubTypes}
          leadsSources={leadsSources}
          dataSource={dataSource}
          actionPaths={actionPaths2}
          startDate={dataSource=='leads-web' ? dateRange.startDate : dateRangeForDownload.startDate}
          endDate={dataSource=='leads-web' ? dateRange.endDate : dateRangeForDownload.endDate}
        />
      </div>
    </main>
  );
};
